var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"5%"}},[_c('h1',[_vm._v("扫码领红包")]),(_vm.wxCode !== null)?_c('van-button',{staticClass:"mr",attrs:{"type":"primary"},on:{"click":_vm.scanCode}},[_vm._v("点击扫码")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }